import React, { useState, useEffect, createContext } from "react";
import { useHistory } from "react-router-dom";

const TicketsContext = createContext();

const TicketsContextProvider = ({ children }) => {
	const history = useHistory();
	const [currentTicket, setCurrentTicket] = useState({ id: null, code: null });
	const [tabOpen, setTabOpenState] = useState(() => {
		try {
			const urlParams = new URLSearchParams(window.location.search);
			const tabParam = urlParams.get("tab");
			if (tabParam && ["pending", "open", "group", "closed"].includes(tabParam)) {
				return tabParam;
			}
			return localStorage.getItem("tickets.manager.lastTab") || "open";
		} catch (_) {
			return "open";
		}
	});

	const setTabOpen = (newTab) => {
		setTabOpenState(newTab);
		try {
			if (newTab) {
				localStorage.setItem("tickets.manager.lastTab", newTab);
			}
		} catch (_) {}
	};

	useEffect(() => {
		if (currentTicket.id !== null) {
			const urlParams = new URLSearchParams(window.location.search);
			const currentTabInUrl = urlParams.get("tab");
			const activeTab = currentTabInUrl === "search" ? "search" : (tabOpen || localStorage.getItem("tickets.manager.lastTab") || "open");
			history.push(`/tickets/${currentTicket.uuid}?tab=${activeTab}`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTicket])

	return (
		<TicketsContext.Provider
			value={{ currentTicket, setCurrentTicket, tabOpen, setTabOpen }}
		>
			{children}
		</TicketsContext.Provider>
	);
};

export { TicketsContext, TicketsContextProvider };
